
import { defineComponent, ref, reactive } from "vue";
import TopBar from "@/components/TopBar.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Footer from "@/components/Footer.vue";
import ChatBox from "@/components/productsBox.vue";
import BackTop from "@/components/BackTop.vue";
import CookieBox from "@/components/CookieBox.vue";
import { ElMessage } from "element-plus";
import { getEmail } from "@/api/contact";

export default defineComponent({
  name: "Global",
  components: {
    TopBar,
    Breadcrumb,
    Footer,
    ChatBox,
    BackTop,
    CookieBox,
  },
  metaInfo: {
    title: "B2B Marketplace - Chemicals & Steel - OTIMES",
    meta: [
      {
        name: "description",
        content: "Distribution of otimes companies in the world",
      },
      {
        name: "keywords",
        content:
          "OTIMES,PLA,PC,POM,PA,ABS,PP,Engineering Plastics,PLASTIC MATERIALS,STEEL,Cold Rolled Steel,Silicon Steel",
      },
    ],
  },
  setup() {
    const contactTag = ref(0);
    const firstName = ref("");
    const lastName = ref("");
    const emailAddress = ref("");
    const content = ref("");
    const msgTagOne = ref(0);
    const msgTagTwo = ref(0);
    const msgTagThree = ref(0);
    const msgTagFour = ref(0);
    const msgTagFive = ref(0);
    const msgTagSix = ref(0);
    const params = reactive({
      content: content,
      startDate: null,
      endDate: null,
      firstName: firstName,
      secondName: lastName,
      email: emailAddress,
    });
    const msg = () => {
      ElMessage({
        message: "Please enter your information.",
        type: "error",
      });
    };
    const success = () => {
      ElMessage({
        message:
          "Thank you for your submission and we will connect you as soon as possible.",
        type: "success",
      });
    };

    const getMessage = () => {
      if (
        firstName.value &&
        lastName.value &&
        emailAddress.value &&
        content.value
      ) {
        getEmail(params);
        success();
        contactTag.value = 0;
        firstName.value = "";
        lastName.value = "";
        emailAddress.value = "";
        content.value = "";
      } else {
        msg();
      }
    };

    return {
      contactTag,
      firstName,
      lastName,
      emailAddress,
      content,
      msgTagOne,
      msgTagTwo,
      msgTagThree,
      msgTagFour,
      msgTagFive,
      msgTagSix,
      msg,
      success,
      params,
      getMessage,
    };
  },
});
